<template>
  <base-layout page-default-back-link="/Home">
    <ion-row>
      <ion-col size="12">
        {{ $t("Segnalazioni") }}
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ion-item>
          <ion-label position="floating">{{ $t("Email") }}</ion-label>
          <ion-input type="email" v-model="txtEmail"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ion-item>
          <ion-label position="floating">{{ $t("Motivo") }}</ion-label>
          <ion-textarea v-model="txtMotivo" rows="10"></ion-textarea>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" style="text-align: center">
        <ion-button @click="Invia_click()"> {{ $t("Invia") }}</ion-button>
      </ion-col>
    </ion-row>
  </base-layout>
</template>

<script>
import { BaseLayout, IonRow, IonCol, IonButton, IonInput, IonLabel, IonItem, IonTextarea, alertController } from "@ionic/vue";
import { DbParamType } from "../components/shared/DbParamType";
import { CommandExecutionType } from "../components/shared/CommandExecutionType";
import { ParameterDirection } from "../components/shared/ParameterDirection";
import { CommandParam } from "../components/shared/CommandParam";
import { dataBoxCall } from "../components/shared/GlobalCallSP";
import { useRouter } from "vue-router";

export default {
  name: "SegnalazioniHome",
  components: {
    BaseLayout,
    IonRow,
    IonCol,
    IonButton,
    IonInput,
    IonLabel,
    IonItem,
    IonTextarea,
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  data() {
    return { txtEmail: "", txtMotivo: "" };
  },
  methods: {
    async presentAlert(Titolo, Testo) {
      const alert = await alertController.create({
        header: Titolo,
        //subHeader: 'Important message',
        message: Testo,
        buttons: ["OK"],
      });

      await alert.present();
    },
    Invia_click() {
      //controllo che ci sia l'email
      if (!this.txtEmail) {
        this.presentAlert(this.$t("Attenzione"), this.$t("errEmail"));
        return;
      }

      if (!this.txtMotivo) {
        this.presentAlert(this.$t("Attenzione"), this.$t("errMotivo"));
        return;
      }
      const self = this;
      let prm = [];
      prm.push(new CommandParam("@Con_toke", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$CON_TOKE));
      prm.push(new CommandParam("@Ind_codi", "", DbParamType.AnsiString, 10, ParameterDirection.Input, this.$IND_CODI));

      prm.push(new CommandParam("@Email", "", DbParamType.AnsiString, 200, ParameterDirection.Input, this.txtEmail));
      prm.push(new CommandParam("@Segnalazione", "", DbParamType.AnsiString, 0, ParameterDirection.Input, this.txtMotivo));
      dataBoxCall
        .Exec(prm, "stpF_InviaSegnalazione_save", true, "", CommandExecutionType.ExecuteQuery, false, this.$DATABOX_CFG)
        .then(function (data) {
          if (data.ErrorMessage) {
            console.warn(data.ErrorMessage);
            self.presentAlert(self.$t("Attenzione"), self.$t("errSegnalazione"));
          } else {
            self.presentAlert(self.$t("Grazie"), self.$t("okSegnalazione"));

            self.txtEmail = "";
            self.txtMotivo = "";
            self.router.push("/");
          }
        })
        .catch(function (er) {
          console.log("return normale no data" + er);
        });
    },
  },
};
</script>
